// All Header options for every route will go here //
const HeaderConfig = (t) => ({
    '/incident-history': {
        showheader: false,
        showSearchBar: false,
        showBackButton: false,
        title: t('History')
    },
    '/incident-history/:id/list/:title': {
        showheader: false,
        showSearchBar: false,
        showBackButton: true,
        title: (params) => `${params.title}`
    },
    '/incident-history/:title/details': {
        showheader: false,
        showSearchBar: false,
        showBackButton: true,
        title: t('IncidentDetails')
    },
    '/live-feed': {
        showheader: false,
        showSearchBar: false,
        showBackButton: false,
        title: t('LiveFeed')
    },
    '/alerts': {
        showheader: false,
        showSearchBar: false,
        showBackButton: false,
        title: t('Alerts'),
        showMarkAsRead: true
    },
    '/alerts/:title/details': {
        showheader: false,
        showSearchBar: false,
        showBackButton: true,
        title: t('IncidentDetails')
    },
    '/settings/account-information': {
        showheader: true,
        showSearchBar: false,
        showBackButton: true,
        title: t('AccountInformation')
    },
    '/settings/appearance': {
        showheader: true,
        showSearchBar: false,
        showBackButton: true,
        title: t('Appearance')
    },
    '/settings/language': {
        showheader: true,
        showSearchBar: false,
        showBackButton: true,
        title: t('Language')
    },
    '/settings': {
        showheader: true,
        showSearchBar: false,
        showBackButton: false,
        title: t('Settings')
    }
});
export default HeaderConfig;
